import { Button, ButtonGroup, Modal } from '@veneer/core';

interface ModalCheckoutCardExp {
  onClosePaymentCardExpTapped: () => void;
  showPaymentCardExpModal: boolean;
}

const ModalCheckoutCardExpPayment = (props: ModalCheckoutCardExp) => {
  return (
    <Modal
      id="payment-card-error"
      closeButton
      onClose={props.onClosePaymentCardExpTapped}
      show={props.showPaymentCardExpModal}
      title="Payment info"
      footer={
        <ButtonGroup>
          <Button onClick={props.onClosePaymentCardExpTapped}>Close</Button>
        </ButtonGroup>
      }
    >
      <p>
        We weren’t able to complete your transaction. Please check your Instant Ink payment information then return here
        to resubmit your order.
      </p>
    </Modal>
  );
};

export default ModalCheckoutCardExpPayment;
